import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-button-loading-spinner',
    templateUrl: './button-loading-spinner.component.html',
    styleUrls: ['./button-loading-spinner.component.scss'],
    standalone: false,
})
export class ButtonLoadingSpinnerComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}
